import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext.jsx';
import AdminDashboard from '../../pages/admin/AdminDashboard.jsx';

// 沒有 dashboard 權限時，依序找第一個有權限的頁面導過去
const FALLBACK = [
  { perm: 'product', to: '/admin/products' },
  { perm: 'theme', to: '/admin/themes' },
  { perm: 'virtual', to: '/admin/virtual' },
  { perm: 'order', to: '/admin/orders' },
  { perm: 'users', to: '/admin/users' },
  { perm: 'roles', to: '/admin/roles' },
  { perm: 'catalog', to: '/admin/settings' },
];

/**
 * 後台首頁：有 dashboard 權限 → 顯示儀表板；
 * 否則自動導到第一個有權限的後台頁（AdminRoute 已保證至少有一個權限）。
 */
function AdminIndex() {
  const { hasPermission } = useAuth();
  if (hasPermission('dashboard')) return <AdminDashboard />;
  const first = FALLBACK.find(x => hasPermission(x.perm));
  return <Navigate to={first ? first.to : '/'} replace />;
}

export default AdminIndex;
